module.exports = __webpack_public_path__ + "img/9788993912043.fd87be8e.jpg";